export function undefinedOrValue(value) {
	if (value instanceof String) {
		value = value.trim();
	}
	return ['', 'null', 'undefined', null, undefined].includes(value) ? null : value
}